import ResourceTyped from './ResourceTyped';

class ContactScraper extends ResourceTyped<any> {
	constructor() {
		super('contactScraper');
	}

	start(clientIds: number[]) {
		return this._postRequest('start', { clientIds });
	}
}

export default new ContactScraper();
